export default __webpack_public_path__ + "static/media/button_enable.4bb3017d.mp3";